import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Package } from '../../models/package.model';

@Component({
  selector: 'app-package-modal',
  templateUrl: './package-modal.component.html',
  styleUrl: './package-modal.component.scss'
})
export class PackageModalComponent {

  @Input() package?: Package;
  
  constructor(
    public activeModal: NgbActiveModal
  ) { }

}
